import accordion from '@primevue/themes/lara/accordion';
import autocomplete from '@primevue/themes/lara/autocomplete';
import avatar from '@primevue/themes/lara/avatar';
import badge from '@primevue/themes/lara/badge';
import base from '@primevue/themes/lara/base';
import blockui from '@primevue/themes/lara/blockui';
import breadcrumb from '@primevue/themes/lara/breadcrumb';
import button from '@primevue/themes/lara/button';
import card from '@primevue/themes/lara/card';
import carousel from '@primevue/themes/lara/carousel';
import cascadeselect from '@primevue/themes/lara/cascadeselect';
import checkbox from '@primevue/themes/lara/checkbox';
import chip from '@primevue/themes/lara/chip';
import colorpicker from '@primevue/themes/lara/colorpicker';
import confirmdialog from '@primevue/themes/lara/confirmdialog';
import confirmpopup from '@primevue/themes/lara/confirmpopup';
import contextmenu from '@primevue/themes/lara/contextmenu';
import datatable from '@primevue/themes/lara/datatable';
import dataview from '@primevue/themes/lara/dataview';
import datepicker from '@primevue/themes/lara/datepicker';
import dialog from '@primevue/themes/lara/dialog';
import divider from '@primevue/themes/lara/divider';
import dock from '@primevue/themes/lara/dock';
import drawer from '@primevue/themes/lara/drawer';
import editor from '@primevue/themes/lara/editor';
import fieldset from '@primevue/themes/lara/fieldset';
import fileupload from '@primevue/themes/lara/fileupload';
import floatlabel from '@primevue/themes/lara/floatlabel';
import galleria from '@primevue/themes/lara/galleria';
import iconfield from '@primevue/themes/lara/iconfield';
import iftalabel from '@primevue/themes/lara/iftalabel';
import image from '@primevue/themes/lara/image';
import imagecompare from '@primevue/themes/lara/imagecompare';
import inlinemessage from '@primevue/themes/lara/inlinemessage';
import inplace from '@primevue/themes/lara/inplace';
import inputchips from '@primevue/themes/lara/inputchips';
import inputgroup from '@primevue/themes/lara/inputgroup';
import inputnumber from '@primevue/themes/lara/inputnumber';
import inputotp from '@primevue/themes/lara/inputotp';
import inputtext from '@primevue/themes/lara/inputtext';
import knob from '@primevue/themes/lara/knob';
import listbox from '@primevue/themes/lara/listbox';
import megamenu from '@primevue/themes/lara/megamenu';
import menu from '@primevue/themes/lara/menu';
import menubar from '@primevue/themes/lara/menubar';
import message from '@primevue/themes/lara/message';
import metergroup from '@primevue/themes/lara/metergroup';
import multiselect from '@primevue/themes/lara/multiselect';
import orderlist from '@primevue/themes/lara/orderlist';
import organizationchart from '@primevue/themes/lara/organizationchart';
import overlaybadge from '@primevue/themes/lara/overlaybadge';
import paginator from '@primevue/themes/lara/paginator';
import panel from '@primevue/themes/lara/panel';
import panelmenu from '@primevue/themes/lara/panelmenu';
import password from '@primevue/themes/lara/password';
import picklist from '@primevue/themes/lara/picklist';
import popover from '@primevue/themes/lara/popover';
import progressbar from '@primevue/themes/lara/progressbar';
import progressspinner from '@primevue/themes/lara/progressspinner';
import radiobutton from '@primevue/themes/lara/radiobutton';
import rating from '@primevue/themes/lara/rating';
import ripple from '@primevue/themes/lara/ripple';
import scrollpanel from '@primevue/themes/lara/scrollpanel';
import select from '@primevue/themes/lara/select';
import selectbutton from '@primevue/themes/lara/selectbutton';
import skeleton from '@primevue/themes/lara/skeleton';
import slider from '@primevue/themes/lara/slider';
import speeddial from '@primevue/themes/lara/speeddial';
import splitbutton from '@primevue/themes/lara/splitbutton';
import splitter from '@primevue/themes/lara/splitter';
import stepper from '@primevue/themes/lara/stepper';
import steps from '@primevue/themes/lara/steps';
import tabmenu from '@primevue/themes/lara/tabmenu';
import tabs from '@primevue/themes/lara/tabs';
import tabview from '@primevue/themes/lara/tabview';
import tag from '@primevue/themes/lara/tag';
import terminal from '@primevue/themes/lara/terminal';
import textarea from '@primevue/themes/lara/textarea';
import tieredmenu from '@primevue/themes/lara/tieredmenu';
import timeline from '@primevue/themes/lara/timeline';
import toast from '@primevue/themes/lara/toast';
import togglebutton from '@primevue/themes/lara/togglebutton';
import toggleswitch from '@primevue/themes/lara/toggleswitch';
import toolbar from '@primevue/themes/lara/toolbar';
import tooltip from '@primevue/themes/lara/tooltip';
import tree from '@primevue/themes/lara/tree';
import treeselect from '@primevue/themes/lara/treeselect';
import treetable from '@primevue/themes/lara/treetable';
import virtualscroller from '@primevue/themes/lara/virtualscroller';

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        datepicker,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        dataview,
        datatable,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        iftalabel,
        floatlabel,
        galleria,
        iconfield,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputotp,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        popover,
        paginator,
        password,
        panel,
        panelmenu,
        picklist,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        ripple,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitter,
        splitbutton,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        textarea,
        tieredmenu,
        tag,
        terminal,
        timeline,
        togglebutton,
        toggleswitch,
        tree,
        treeselect,
        treetable,
        toast,
        toolbar,
        tooltip,
        virtualscroller
    }
};
